import BaseMystery from '../BaseMystery'

const FourthSorrowfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/b/bosch/1early/12carry.jpg",
		"https://www.wga.hu/art/b/bles/christ_c.jpg",
		"https://www.wga.hu/art/b/benvenut/predell1.jpg",
		"https://www.wga.hu/art/b/baegert/carrying.jpg",
		"https://www.wga.hu/art/b/bosch/5panels/13carryi.jpg",
		"https://www.wga.hu/art/b/bosch/5panels/14carryi.jpg",
		"https://www.wga.hu/art/b/bruegel/pieter_e/08/11calvar.jpg",
		"https://www.wga.hu/art/c/catena/carrying.jpg",
		"https://www.wga.hu/art/c/cranach/lucas_e/05/61religi.jpg",
		"https://www.wga.hu/art/f/floris/cornelis/carrying.jpg",
		"https://www.wga.hu/art/f/francken/hierony3/carrying.jpg",
		"https://www.wga.hu/art/g/gossart/04religi/5carryin.jpg",
		"https://www.wga.hu/art/g/greco_el/08/0811grec.jpg",
		"https://www.wga.hu/art/g/greco_el/15/1503grec.jpg",
		"https://www.wga.hu/art/g/grimmer/abel/carrying.jpg",
		"https://www.wga.hu/art/g/grunewal/4/3carry.jpg",
		"https://www.wga.hu/art/h/hemessen/jan/christ.jpg",
		"https://www.wga.hu/art/j/juan/1/carrying.jpg",
		"https://www.wga.hu/art/l/ligozzi/carrying.jpg",
		"https://www.wga.hu/art/l/lotto/4/01carry.jpg",
		"https://www.wga.hu/art/m/maineri/carrying.jpg",
		"https://www.wga.hu/art/m/master/ms/5carry.jpg",
		"https://www.wga.hu/art/m/master/thomas/3garam.jpg",
		"https://www.wga.hu/art/m/melone/christx.jpg",
		"https://www.wga.hu/art/m/memling/6copies/08notri3.jpg",
		"https://www.wga.hu/art/m/morales/christ_c.jpg",
		"https://www.wga.hu/art/m/multsche/wurzach/3carry.jpg",
		"https://www.wga.hu/art/n/naldini/carrying.jpg",
		"https://www.wga.hu/art/p/pordenon/cremona/cremona7.jpg",
		"https://www.wga.hu/art/r/romanino/carrying.jpg",
		"https://www.wga.hu/art/s/salviati/1/christ.jpg",
		"https://www.wga.hu/art/s/schaufel/altar2d.jpg",
		"https://www.wga.hu/art/s/sebastia/carrying.jpg",
		"https://www.wga.hu/art/s/simone/7last/orsini/5orsini.jpg",
		"https://www.wga.hu/art/t/tiepolo/gianbatt/2_1730s/11alvisf.jpg",
		"https://www.wga.hu/art/t/tiepolo/gianbatt/2_1730s/11alvise.jpg",
		"https://www.wga.hu/art/t/tiziano/01_1510s/01carryi.jpg",
		"https://www.wga.hu/art/t/tiziano/06_1560s/06carryi.jpg",
		"https://www.wga.hu/art/t/tiziano/07_1570s/04carryi.jpg",
		"https://www.wga.hu/art/v/valdes/juan/carrying.jpg",
		"https://www.wga.hu/art/v/vecchi/carrying.jpg",
		"https://www.wga.hu/art/v/vivarini/alvise/carrying.jpg",
		"https://www.wga.hu/art/v/voet_a/carrying.jpg",
	];

	const scriptureQuote = "So they took Jesus, and carrying the cross himself he went out to what is called the Place of the Skull, in Hebrew, Golgotha.";
	const scriptureCitation = "John 19:16-17 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=John%2019%3A15-17%3B%20Luke%2023%3A26&version=NABRE";

	return (
		<BaseMystery titleText="The Carrying of the Cross"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default FourthSorrowfulMystery;